<template>
  <div :class="{ 'flex-row-reverse': reverseOrder }"
       class="text-right d-flex">
    <ButtonElement v-if="showTertiaryButton"
                   :class="{ 'mr-2': !reverseOrder }"
                   :text="displayedTertiaryButtonText"
                   name="tertiary-button"
                   :icon-name="tertiaryButtonIconName"
                   :variant="BootstrapVariant.SECONDARY"
                   :size="size"
                   @click="onTertiaryButtonClick">
    </ButtonElement>
    <ButtonElement :class="{ 'mr-2': !reverseOrder }"
                   :text="displayedSecondaryButtonText"
                   name="secondary-button"
                   :icon-name="secondaryButtonIconName"
                   :variant="BootstrapVariant.SECONDARY"
                   :disabled="secondaryButtonDisabled"
                   :size="size"
                   @click="onSecondaryButtonClick">
    </ButtonElement>
    <ButtonElement v-if="hidePrimaryButton === false"
                   :class="{ 'mr-2': reverseOrder }"
                   :text="displayedPrimaryButtonText"
                   name="primary-button"
                   :icon-name="primaryButtonIconName"
                   :disabled="primaryButtonDisabled"
                   :size="size"
                   @click="onPrimaryButtonClick">
    </ButtonElement>
  </div>
</template>

<script>
  import ButtonElement from './ButtonElement.vue';
  import ButtonPosition from '~/zf/frontend/common/layout/ButtonPosition';
  import BootstrapVariant from '~/zf/frontend/vendor/bootstrap/BootstrapVariant';
  import translator from '~/zf/frontend/common/mixins/translator';

  export default {
    name: 'ButtonGroup',
    compatConfig: {
      MODE: 3,
    },
    components: { ButtonElement },
    mixins: [translator],
    props: {
      hidePrimaryButton: {
        type: Boolean,
        default: false,
      },
      showTertiaryButton: {
        type: Boolean,
        default: false,
      },
      primaryButtonText: {
        type: String,
      },
      primaryButtonIconName: {
        type: String,
        default: 'checkmark',
      },
      primaryButtonPosition: {
        type: String,
        default: ButtonPosition.RIGHT,
      },
      secondaryButtonText: {
        type: String,
      },
      secondaryButtonIconName: {
        type: String,
        default: 'cancel-circle',
      },
      tertiaryButtonText: {
        type: String,
      },
      tertiaryButtonIconName: {
        type: String,
      },
      primaryButtonDisabled: {
        type: Boolean,
        default: false,
      },
      secondaryButtonDisabled: {
        type: Boolean,
        default: false,
      },
      size: {
        type: String,
        default: BootstrapVariant.MEDIUM,
      },
    },
    emits: ['primary-button-click', 'secondary-button-click', 'tertiary-button-click'],
    data() {
      return {
        BootstrapVariant,
      };
    },
    computed: {
      displayedPrimaryButtonText() {
        return this.primaryButtonText ?? this.tr('javascript.TX_OK');
      },
      displayedSecondaryButtonText() {
        return this.secondaryButtonText ?? this.tr('javascript.TX_ABORT');
      },
      displayedTertiaryButtonText() {
        return this.tertiaryButtonText ?? this.tr('javascript.TX_CLOSE');
      },
      reverseOrder() {
        return this.primaryButtonPosition === ButtonPosition.LEFT;
      },
    },
    methods: {
      onPrimaryButtonClick(event) {
        this.$emit('primary-button-click', event);
      },
      onSecondaryButtonClick() {
        this.$emit('secondary-button-click');
      },
      onTertiaryButtonClick() {
        this.$emit('tertiary-button-click');
      },
    },
  };
</script>
